<div class="dateCircle">
  <span class="month">{{ dateMonth }}</span> <span class="day">{{ dateDay }}</span>
</div>
